import { Crisp } from "crisp-sdk-web";
import {
  getAnalytics,
  logEvent,
  setCurrentScreen,
  setUserId,
} from "firebase/analytics";

class FelixAnalytics {
  private static _instance: FelixAnalytics;

  public static getInstance(): FelixAnalytics {
    if (!FelixAnalytics._instance) {
      FelixAnalytics._instance = new FelixAnalytics();
    }

    return FelixAnalytics._instance;
  }

  public identify(id: string): void {
    setUserId(getAnalytics(), id);
  }
  public track(name: string, props: any = {}): void {
    logEvent(getAnalytics(), name, props);
    Crisp.session.pushEvent(name, props);
  }
  public setCurrentPage(page: string): void {
    setCurrentScreen(getAnalytics(), page);
    Crisp.session.pushEvent("currentPage", { page });
  }
}

export default FelixAnalytics.getInstance();
